import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Upload from "../../../../../../../../common/element/Upload";
import { UpdateInductionModuleData } from "../../../../../../../../redux/classes/client-portal/inductionModuleDataSlice";
import ImgUpload from "../../../../../../../../assets/icons-svg/image-01.svg";
import { UpdateInductionStatus } from "../../../../../../../../redux/classes/client-portal/updateInductionSlice";
import { DeletedocumentData } from "../../../../../../../../redux/classes/client-portal/deletedocument";

import { DeleteCompanyIndModuleFileById} from "../../../../../../../../actions/Admin-Client/AllCompanyInduction";
import { closeDocumentfunc } from "../../../../../../../../redux/classes/client-portal/closeDocument";
import { Tooltip } from "@material-ui/core";
import { GetSignedUrlByKey } from "../../../../../../../../actions/public/GetSignedUrlByKey";
const ImgFile = (props) => {
  const [fileUpload, setFile] = useState("");
  const [UrlFile, setUrlFile] = useState("");
  const { InductionModuleData } = useSelector((state) => state);
  const [checkPdf, SetcheckPdf] = useState("");
  const [sizeError, SetsizeError] = useState("");
  const [Pdfdata, Setpdfdata] = useState(InductionModuleData[props.indexData]);
  const dispatch = useDispatch();

  const handleFileChange = (e) => {
    dispatch(UpdateInductionStatus(true));
    if (e[e.length - 1].size <= 25 * 1024 * 1024) {
      SetcheckPdf(e[e.length - 1]);
      const file = e[0];
      Setpdfdata({
        ...Pdfdata,
        content_info_type: "file",
        company_ind_file: file,
      });
      SetsizeError("");
    } else {
      SetsizeError("File size exceeds the maximum limit of 25MB.");
    }
  };
  useEffect(() => {
    dispatch(
      UpdateInductionModuleData({
        indexData: props.indexData,
        moduleData: Pdfdata,
      })
    );
  }, [Pdfdata]);

  useEffect(() => {
    let fileName;
    if (Pdfdata?.company_ind_file?.name !== undefined) {
      fileName = Pdfdata.company_ind_file.name;
      SetcheckPdf(Pdfdata.company_ind_file);
    } else {
      fileName = Pdfdata.content_info;
      if (Pdfdata.content_info) {
        dispatch(
          GetSignedUrlByKey(
            { url: Pdfdata.content_info },
            "admin/client"
          )
        ).then((response) => {
          if (response.success) {
            // setPdfFile(response?.data);
            SetcheckPdf(response?.data);
          }
        });
      }
      
    }
  }, []);

  const handleDeletePDF = () => {
    dispatch(closeDocumentfunc(true))
    dispatch(UpdateInductionStatus(true));
    SetcheckPdf("");
    Setpdfdata({ ...Pdfdata, content_info_type: "", company_ind_file: "",content_info:"" });
    if(((Pdfdata?.module_id)&&(Pdfdata?.content_info_type=="file") && (Pdfdata?.content_info))){
      dispatch(DeleteCompanyIndModuleFileById({module_id:Pdfdata.module_id,content_info:Pdfdata.content_info}))
    }
  };
  // const {deletedocument}=useSelector((state)=>state)
  //   useEffect(()=>{
  // if (deletedocument) {
  //   handleDeletePDF();
  //   dispatch(DeletedocumentData(false));
  // }
  return (
    <React.Fragment>
      <div className="flex w-full gap-5 items-center relative">
      <Tooltip placement={"right-start"} title={"Remove module content"}>
          <button
            onClick={() => handleDeletePDF()}
            className="modue_creation_close_icon absolute right-0 bottom-full"
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m18 6.5-12 12m0-12 12 12"
                stroke="#667085"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </Tooltip>
        <div className="p-4 rounded-xl border border-gray-300 flex items-center justify-between w-2/4">
        {checkPdf?.length == 0 && (
            <Upload
              value={""}
              accept={".jpg, .jpeg, .png, .gif"}
              showList={false}
              onChange={handleFileChange}
              draggable
              className="w-full"
            >
                <div className="text-center">
                <div className="flex items-center justify-center flex-col">
                  {" "}
                  <span className="flex w-9 h-9 items-center justify-center rounded-full bg-gray-200 outline outline-8 outline-gray-50 outline-offset-0">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.667 13.333 10 10m0 0 3.333 3.333M10 10v7.5m6.666-3.548a4.583 4.583 0 0 0-2.917-8.12.516.516 0 0 1-.444-.25 6.25 6.25 0 1 0-9.816 7.58"
                        stroke="#475467"
                        strokeWidth="1.667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                  <span className="pt-4">
                    <span className="text-blue-700 font-semibold mr-1">
                      Click to upload
                    </span>{" "}
                    <span className="text-xs text-gray-600">
                      {" "}
                      or drag and drop ( max. 25mb)
                    </span>
                  </span>
                </div>
              </div>
              {sizeError && (
                <div className="text-red-500 text-sm mt-1">{sizeError}</div>
              )}
            </Upload>
          )}
         {checkPdf?.length != 0 && (
         <React.Fragment>
          <div className="flex  gap-4">
            <span className="w-9 h-9 rounded-full border-4 border-blue-50 bg-blue-200 flex justify-center items-center">
              <img src={ImgUpload} alt="" />
            </span>
            <div className="flex flex-col">
              <span className="text-gray-700 text-xs font-medium">
              {checkPdf?.name ? checkPdf?.name : props.size.name}
              </span>
              {/* <span className="text-gray-600 text-xs">
                {checkPdf?.size
                      ? `${(checkPdf?.size / 1024 / 1024).toFixed(2)} MB`
                      : `${(props.size.size / 1024).toFixed(2)} MB`}
              </span> */}
            </div>
          </div>
          <button onClick={handleDeletePDF}>
            <svg
              width="20"
              height="19"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 3.5h6m-12 3h18m-2 0-.701 10.52c-.105 1.578-.158 2.367-.499 2.965a3 3 0 0 1-1.298 1.215c-.62.3-1.41.3-2.993.3h-3.018c-1.582 0-2.373 0-2.993-.3A3 3 0 0 1 6.2 19.985c-.34-.598-.394-1.387-.499-2.966L5 6.5m5 4.5v5m4-5v5"
                stroke="#344054"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          </React.Fragment>
          )}
        </div>
      </div>
   

    </React.Fragment>
  );
};

export default ImgFile;
